module.exports = __webpack_public_path__ + "img/signal_wifi_4_bar.65a2415c.svg";